document.addEventListener('DOMContentLoaded', function () {
  // Fixed header: measure its real height (varies with logo size / mobile
  // breakpoint) and expose it as a CSS variable so page content sits right
  // below it instead of underneath it.
  var siteHeader = document.querySelector('[data-header]');
  if (siteHeader) {
    var setHeaderHeight = function () {
      document.documentElement.style.setProperty('--site-header-height', siteHeader.offsetHeight + 'px');
    };
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);
    window.addEventListener('load', setHeaderHeight);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(setHeaderHeight);
    }
  }

  var messageField = document.querySelector('[data-message-field]');
  if (messageField) {
    var params = new URLSearchParams(window.location.search);
    var productName = params.get('product');
    if (productName && !messageField.value) {
      messageField.value = 'I\'m interested in B2B pricing for: ' + productName + '\n\n';
    }
  }

  var mainImage = document.querySelector('[data-main-image]');
  var thumbs = document.querySelectorAll('.product-detail__thumb');
  if (mainImage && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-media-src');
        var alt = thumb.getAttribute('data-media-alt');
        if (src) {
          mainImage.src = src;
          mainImage.srcset = '';
          if (alt) mainImage.alt = alt;
        }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    var gallery = document.querySelector('[data-gallery]');
    if (gallery) {
      function goToNext(diff) {
        if (Math.abs(diff) < 40) return;
        var activeIndex = 0;
        thumbs.forEach(function (t, i) { if (t.classList.contains('is-active')) activeIndex = i; });
        var nextIndex = diff > 0 ? activeIndex + 1 : activeIndex - 1;
        if (nextIndex >= 0 && nextIndex < thumbs.length) {
          thumbs[nextIndex].click();
        }
      }

      var startX = 0;
      gallery.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        goToNext(startX - e.changedTouches[0].clientX);
      }, { passive: true });

      var isDragging = false;
      var dragStartX = 0;
      gallery.style.cursor = 'grab';
      gallery.addEventListener('mousedown', function (e) {
        isDragging = true;
        dragStartX = e.clientX;
        gallery.style.cursor = 'grabbing';
        e.preventDefault();
      });
      window.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
      });
      window.addEventListener('mouseup', function (e) {
        if (!isDragging) return;
        isDragging = false;
        gallery.style.cursor = 'grab';
        goToNext(dragStartX - e.clientX);
      });
    }
  }

  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var isHidden = mobileNav.hasAttribute('hidden');
      if (isHidden) {
        mobileNav.removeAttribute('hidden');
        menuToggle.setAttribute('aria-expanded', 'true');
      } else {
        mobileNav.setAttribute('hidden', '');
        menuToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  var searchClose = document.querySelector('[data-search-close]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      searchPanel.toggleAttribute('hidden');
      var input = searchPanel.querySelector('input[type="search"]');
      if (input && !searchPanel.hasAttribute('hidden')) input.focus();
    });
  }
  if (searchClose && searchPanel) {
    searchClose.addEventListener('click', function () {
      searchPanel.setAttribute('hidden', '');
    });
  }
});
